import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-inspections-notes',
  standalone: false,
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent {
  @Input() applicationId = '';
  @Input() applicationNumber = '';
}
